<template>
  <div
    class="address-management"
    :class="addressList.length < 1 && page > 1 ? 'on' : ''"
    ref="container"
  >
    <div class="line" v-if="addressList.length > 0">
      <img src="@assets/images/line.jpg" />
    </div>
    <div class="item" v-for="(item, index) in addressList" :key="index">
      <div class="address">
        <div class="consignee">
          收货人：{{ item.real_name
          }}<span class="phone">{{ item.phone }}</span>
        </div>
        <div>
          收货地址：{{ item.province }}{{ item.city }}{{ item.district
          }}{{ item.detail }}
        </div>
      </div>
    </div>
    <div class="noCommodity" v-if="addressList.length < 1 && page > 1">
      <div class="noPictrue">
        <img src="@assets/images/noAddress.png" class="image" />
      </div>
    </div>
  </div>
</template>
<style scoped>
.address-management.on {
  background-color: #fff;
  height: 100vh;
}
</style>
<script type="text/babel">
import { getUserAddress } from "@api/order";

export default {
  data() {
    return {
      page: 1,
      limit: 20,
      addressList: []
    };
  },
  mounted: function() {
    this.AddressList();
  },
  methods: {
    /**
     * 获取地址列表
     *
     */
    AddressList: function() {
      getUserAddress()
        .then(res => {
          console.log(res);
          this.addressList = res.data;
        })
        .catch(err => {
          if (err.msg == "ok") {
            this.addressList = err.data.data;
          }
        });
    }
  }
};
</script>
